import React from "react";

export default function SQL_Syntax() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_Syntax</h1>
      <p>This is the SQL_Syntax component generated from the SQL JSON.</p>
    </div>
  );
}
